import { render, staticRenderFns } from "./ipLock.vue?vue&type=template&id=2a9c56ea"
import script from "./ipLock.vue?vue&type=script&lang=js"
export * from "./ipLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports